import store from '@/store/index.js';
import modeConst from '@/consts/mode.const.js';

/**
 *  This guard set research mode in the store.
 */
const pixResearchDashboardGuard = async (to, from, next) => {
  store.commit('setMode', modeConst.RESEARCH);

  next();
};

export default pixResearchDashboardGuard;
